if (!customElements.get("product-price-teaser")) {
    class ProductPriceTeaser extends CustomElement {
        get refs() {
            return {
                $variantSelects: $("variant-selects"),
            };
        }

        constructor() {
            super();
            window.addEventListener("productVariantChange", debounce(this.onProductVariantChange.bind(this), 100));
        }

        mounted() {
            super.mounted();
            this.onProductVariantChange();
        }

        onProductVariantChange() {
            const { $variantSelects } = this.refs;
            const currentVariant = $variantSelects.get(0)?.currentVariant;

            if (!currentVariant) return;

            const price = currentVariant.price / 100,
                originalPrice = (currentVariant.compare_at_price / 100) || price;

            this.renderPriceTag({ price, originalPrice });
        }

        renderPriceTag({ price, originalPrice }) {
            const isOnSale = originalPrice > price,
                priceInCurrency = Currency.format(price, { maximumFractionDigits: price % 1 === 0 ? 0 : 2 }),
                originalPriceInCurrency = Currency.format(originalPrice, { maximumFractionDigits: originalPrice % 1 === 0 ? 0 : 2 }),
                discountPercentage = isOnSale ? Math.round(((originalPrice - price) / originalPrice) * 100) : 0;

            this.$el.find("[data-sale-price]").text(priceInCurrency);
            this.$el.find("[data-regular-price]").text(isOnSale ? originalPriceInCurrency : "");
            this.$el.find("[data-discount-badge]").text(isOnSale ? `-${discountPercentage}%` : "").toggle(isOnSale);
        }
    }

    customElements.define("product-price-teaser", ProductPriceTeaser);
}
